// Utility to generate random data for the dashboard
export const getRandomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}
export const formatNumber = (num: number) => {
  return new Intl.NumberFormat('zh-CN').format(num)
}
// Simulate data fetching for different modules
export const getModuleData = (moduleId: string) => {
  switch (moduleId) {
    case 'safety':
      return {
        label: '今日监测',
        value: `${getRandomInt(89, 128)}个点位`,
        subLabel: '异常预警',
        subValue: `${getRandomInt(0, 2)}次`,
      }
    case 'classroom':
      return {
        label: '课堂分析',
        value: `${getRandomInt(180, 280)}节`,
        subLabel: '互动数据',
        subValue: `${formatNumber(getRandomInt(1200, 2500))}次`,
      }
    case 'growth':
      return {
        label: '健康评估',
        value: `${formatNumber(getRandomInt(1800, 2400))}人`,
        subLabel: '心理干预',
        subValue: `${getRandomInt(30, 80)}次`,
      }
    case 'knowledge':
      return {
        label: '作业批改',
        value: `${formatNumber(getRandomInt(2500, 4500))}份`,
        subLabel: '知识点诊断',
        subValue: `${formatNumber(getRandomInt(800, 1500))}个`,
      }
    case 'ai-tutor':
      return {
        label: '今日辅导',
        value: `${formatNumber(getRandomInt(800, 1500))}人次`,
        subLabel: '问题解答',
        subValue: `${formatNumber(getRandomInt(3000, 6000))}个`,
      }
    default:
      return { label: '-', value: '-', subLabel: '-', subValue: '-' }
  }
}
